import { FormGroup } from '@angular/forms'
import { ISO8601Format } from './date.util'

export const urlParseTemplate = (url: string, params: Record<string, string | number | boolean>): string => {
    for (const [key, value] of Object.entries(params)) {
        url = url.replace(new RegExp(escapeRegExp(`{${key}}`), 'g'), value.toString())
    }

    const parts = splitUrl(url)
    url = parts.length == 1 ? parts[0].replace(/\/\//g, '/') : parts[0] + parts[1].replace(/\/\//g, '/')

    return url
}

function splitUrl(url: string) {
    const parts = url.split('://')

    if (parts.length > 1) {
        parts[0] = parts[0] + '://'
    }
    return parts
}

function escapeRegExp(string: string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

export const replaceLineBreaks = (input: string) => {
    return input.replace(/(\r\n|\n|\r)/g, '<br />')
}

export const getYoutubeVideoId = (videoUrl: string) => {
    const url = new URL(videoUrl)
    return url.searchParams.get('v')
}

export const addOrSubtractDays = (startingDate: Date, number: number, add = true): Date => {
    if (add) {
        return new Date(startingDate.setDate(startingDate.getDate() + number))
    }

    return new Date(startingDate.setDate(startingDate.getDate() - number))
}

export const isDateGreaterThan = (date1: Date, date2: Date): boolean => {
    const newDate1 = new Date(date1)
    const newDate2 = new Date(date2)

    return newDate1.getTime() >= newDate2.getTime()
}

export const valueHasChanged = <T>(newValues: FormGroup, oldValues: T): boolean => {
    let output = false
    Object.entries(newValues).map(([key, value]) => {
        let oldValue: string =
            oldValues && typeof oldValues[key as keyof T] !== 'undefined'
                ? unknownToString(oldValues[key as keyof T])
                : ''
        let newValue: string = unknownToString(value)

        const isDate = value ? isValidUTCDate(oldValue.toString()) : false

        if (isDate) {
            oldValue = new Date(oldValue).toUTCString()
            newValue = new Date(newValue).toUTCString()
        }

        if (isValidGTMDate(newValue)) {
            newValue = ISO8601Format(new Date(newValue))
        }

        if (oldValue !== newValue) {
            output = true
        }
    })

    return output
}

export const unknownToString = (value: unknown): string => {
    return value === null || value === undefined ? '' : value.toString()
}

export const isValidUTCDate = (value: string): boolean => {
    return value.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/) ? true : false
}

export const isValidGTMDate = (value: string): boolean => {
    const dateRegex =
        /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{2}) \d{4} \d{2}:\d{2}:\d{2} GMT([+-]\d{4}) \(.+\)$/
    return value.match(dateRegex) ? true : false
}
